export enum ThirdPartyMessageStatus {
    cancelled = 'cancelled',
    failed = 'failed',
    paused = 'paused',
    retrying = 'retrying',
    scheduled = 'scheduled',
    sending = 'sending',
    sent = 'sent',
}
